import { useQuery } from "@tanstack/react-query";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { ServiceContract } from "../../types/service.type";
import { getContractDetails } from "../services/goHireService";

export const useGetContractDetails = (contractId: number) => {
  return useQuery<ServiceContract>({
    queryKey: GO_SERVICE_QUERY_KEYS.contractDetails(contractId),
    queryFn: () => getContractDetails(contractId),
    enabled: !!contractId,
  });
};
